import BaseDialog from '@components/shared/Dialog/BaseDialog';
import { useLocalStorage } from '@utils/hooks';

type NotificationDialogProps = {
  children: React.ReactNode;
  notificationKey: string;
};

export const NotificationDialog = (props: NotificationDialogProps) => {
  const [notificationSeen, setNotificationSeen] = useLocalStorage(
    `notifications:${props.notificationKey}`,
    false
  );

  return (
    <BaseDialog
      title="Notice"
      open={!notificationSeen}
      onClose={() => setNotificationSeen(true)}
    >
      {props.children}
    </BaseDialog>
  );
};
